const innovative = [
  {
    path: '/giant',
    name: 'giant',
    meta: { title: '专精特新“小巨人”企业评估测试', node: 'giant', reviewType: 7 },
    component: () => import('../views/giant/index.vue')
  },
  {
    path: '/giant_evaluation',
    name: 'giant_evaluation',
    meta: { title: '专精特新“小巨人”企业评估测试', node: 'giant', reviewType: 7, childNode: true },
    component: () => import('../views/giant/evaluation.vue')
  },
  {
    path: '/giant_result',
    name: 'giant_result',
    meta: { title: '专精特新“小巨人”企业评估测试结果', node: 'giant', reviewType: 7 },
    component: () => import('../views/giant/result.vue')
  }
]

export default innovative;